import { observable, action } from 'mobx';

class UnreadMsgStore {
  @observable messageList: Array<any> = [];

  @action
  updateMessageList(messageList: Array<any>) {
    this.messageList = [...messageList];
  }

}

const unreadMsgStore = new UnreadMsgStore();

export default unreadMsgStore;
